import PageProtectedLayout from "../../../../components/Page/PageProtectedLayout.jsx";
import SelectDatePsa from "./SelectDatePsa.jsx";
import { useAuth } from "../../../../provider.jsx";
import { useTranslation } from '../../../../language';
import { Stack, Typography} from "@mui/material";
import { Mars  } from 'lucide-react';

export default function BloodPsaWelcome() {

  const { state } = useAuth();
  const gender = state?.user?.gender;
  const isFemale = gender === "F";
  const { t } = useTranslation();

return (

    <PageProtectedLayout

      headline={t('page_hl_pros')}
      specify={t('page_sp_prostate_cancer_prevention')}

      >

        {isFemale ? (

        <Stack direction ="row" spacing={4} sx={{mt:2}}>
          <Mars size={30} />
          <Typography variant="subtitle1" sx={{fontWeight: 500}}>
            This section content is available for male users only.
          </Typography>
        </Stack>
      ) : (

       <SelectDatePsa />

       )}

    </PageProtectedLayout>

  );
}
